import axios from "axios";

export default {
  async fetchSharedProject(shareCode) {
    return axios.get(api_url + user_role + "/projects/shared/" + shareCode);
  }
};



// WEBPACK FOOTER //
// ./src/api/project.js